// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"70990705","329":"c4ace0f4","373":"04e68862","381":"3393ec34","488":"ea9e37ca","947":"de219375"}[chunkId] + ".chunk.js";
};